<template>
    <div
        class="flex items-center py-2 px-2 cursor-pointer"
        :class="isSelected ? 'bg-primary-3/30 text-white' : 'hover:bg-default-10'"
    >
        <component :is="documentIcon" :color="fullConfig.theme.colors.primary[1]" class="w-5 ml-4.5 flex-shrink-0" />
        <div
            class="ml-4.5 pr-4 text-body-6 pl-3 box-border flex-shrink-0 overflow-hidden text-ellipsis text-default-1 whitespace-nowrap capitalize"
            @click="emit('select', document)"
        >
            {{ document.documentable.title }}
        </div>
        <img
            v-if="document.documentable.has_children && !loaders.includes(document.uid)"
            src="@/assets/icons/chevron-down.svg"
            alt="toggle"
            class="w-4 h-4 flex-shrink-0 transition-all"
            :class="!document.toggled && '-rotate-90'"
            @click="toggleFolder(document)"
        />
        <Spinner
            v-if="loaders.includes(document.uid)"
            class="!w-6 !h-6 !-ml-2 !mr-0 flex-shrink-0"
            color="#000000"
        />
        <div class="flex flex-1 h-4" @click="emit('select', document)"></div>
    </div>
    <div class="w-full pl-3 box-border" v-if="document.documentable.has_children && document.toggled">
        <ul>
            <li
                class="w-full cursor-pointer flex flex-col"
                v-for="(childDoc) in document.children"
                :key="childDoc.uid"
            >
                <FolderRow
                    :document="childDoc"
                    :selected-folder="selectedFolder"
                    @select="selectFolder"
                    @toggle="toggleFolder"
                    :loaders="loaders"
                />
            </li>
            <div v-if="document.children && document.children.length === 0 && !loaders.includes(document.uid)" class="text-body-7 text-default-2 pl-[28px]">No folders eligible</div>
        </ul>
    </div>
</template>

<script setup>
import FolderIcon from '@/components/icons/small/Documents/Folder.vue';
import FileIcon from '@/components/icons/small/Documents/FileDoc.vue';
import PDFIcon from '@/components/icons/small/Documents/FilePDF.vue';
import ImageIcon from '@/components/icons/small/Documents/FileJPG.vue';
import Spinner from '@/components/icons/Spinner.vue';

import {computed} from "vue";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from '@/../tailwind.config.js'

const props = defineProps({
    document: {
        type: Object,
        required: true
    },
    selectedFolder: {
        type: Object,
        default: null
    },
    loaders: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['toggle', 'select']);

const icons = {
    folder: FolderIcon,
    file: FileIcon,
    pdf: PDFIcon,
    image: ImageIcon
}

const fullConfig = resolveConfig(tailwindConfig)

function toggleFolder(folder) {
    emit('toggle', folder);
}

function selectFolder(folder) {
    emit('select', folder);
}

const documentIcon = computed(() => {
    if(props.document.documentable_type === 'folder') {
        return icons['folder'];
    }

    if(props.document.documentable.title.includes('.pdf')) {
        return icons['pdf'];
    }

    if(props.document.documentable.title.includes('.jpg')) {
        return icons['image'];
    }

    return icons['file'];
})

const isSelected = computed(() => {
    return props.selectedFolder && props.selectedFolder.uid === props.document.uid;
})
</script>